import { z } from 'zod'

export const CmsAssetSchema = z
  .object({
    uid: z.string(),
    url: z.string(),
    title: z.string(),
    filename: z.string(),
    content_type: z.string(),
  })
  .passthrough()

export const CmsLinkSchema = z
  .object({
    title: z.string(),
    href: z.string(),
  })
  .passthrough()

export const CmsReferenceSchema = z
  .object({
    uid: z.string(),
    _content_type_uid: z.string(),
  })
  .passthrough()

// CS rich text JSON is too variable to model strictly; runtime validation
// only confirms shape at the field-presence level. The `.refine` rejects
// `undefined` so that a mandatory RTE field (generated without `.optional()`)
// is actually required — a bare `z.unknown()` treats the key as optional and
// would let a missing required field pass the gate. Blocks that need to read
// inside an RTE payload should validate further at the use site.
export const RichTextContentSchema = z
  .unknown()
  .refine((value) => value !== undefined, { message: 'Required' })
